import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Modal,
  Box,
  Icon,
  CircularProgress
} from "@mui/material";
import Page from "../components/Page";
import { Grid } from "@mui/material";
import Select from "react-select";
import { notification } from "src/utils/messages";
import DataTable from "react-data-table-component";
import { ReplayCircleFilledOutlined, ReportGmailerrorredOutlined } from "@mui/icons-material";
import { CSVLink } from "react-csv";
import Label from "src/components/Label";
import { approveCancelMemberRequest, getCancelMemberRequestList } from "src/api/commonapi";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import CustomLoader from "src/components/CustomLoader";

export default function CancelMembershipRequest() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [isLoading, setIsLoading] = useState(false);
  const [approveMemberRequestModal, setApproveMemberRequestModal] = useState(false);
  const [cancelRequestId, setCancelRequestId] = useState({});

  const requestPendingApproveOptions = [
    { label: "All", value: -1 },
    { label: "Pending", value: 0 },
    { label: "Approved", value: 1 }
  ];

  const [searchdata, setsearchdata] = useState({
    status: -1,
    searchmember: "",
    startDate: null,
    endDate: null
  });
  const [requestData, setRequestData] = useState([]);
  const [newOBTData, setNewRequestData] = useState([]);

  const columns = [
    {
      name: "No",
      selector: (row, index) => index + 1,
      wrap: true,
      width: "70px",
      sortable: true
    },
    {
      name: "Member Name",
      selector: (row) => row.m_name,
      sortable: true,
      wrap: true
    },
    {
      name: "Mobile No",
      selector: (row) => row.mobile_no,
      sortable: true,
      width: "130px",
      wrap: true
    },
    {
      name: "Joining Date",
      selector: (row) => row.joining_date,
      sortable: true,
      width: "130px",
      wrap: true
    },
    {
      name: "Request Date",
      selector: (row) => row.request_date,
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
      wrap: true
    },
    {
      name: "Reason",
      selector: (row) => (row.cancel_request_reason ? row.cancel_request_reason : "-"),
      sortable: true,
      wrap: true
    },
    {
      name: "Approve Date",
      selector: (row) => (row.request_accept_date ? row.request_accept_date : "-"),
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Status",
      wrap: false,
      selector: (row) => (
        <Label
          variant="ghost"
          color={
            row.cancel_request_status == 1
              ? "success"
              : row.cancel_request_status == 2
                ? "error"
                : "warning"
          }
          style={{
            marginBottom: "10px",
            display: "flex",
            fontSize: "12px",
            fontWeight: "normal"
          }}
        >
          {row.cancel_request_status == 1
            ? "Approved"
            : row.cancel_request_status == 2
              ? "Rejected"
              : "Pending"}
        </Label>
      ),
      sortable: false
    },
    {
      name: "Action",
      sortable: true,
      wrap: true,
      selector: (row) =>
        row.cancel_request_status != 1 ? (
          <>
            <Tooltip title="Approve Cancel Request">
              <IconButton
                onClick={() => {
                  setCancelRequestId(row);
                  setApproveMemberRequestModal(true);
                }}
              >
                <ReplayCircleFilledOutlined color="success" />
              </IconButton>
            </Tooltip>
          </>
        ) : null
    }
  ];

  const ClearSearchResult = async () => {
    setsearchdata({
      status: -1,
      searchmember: "",
      startDate: null,
      endDate: null
    });
  };

  const filterData = () => {
    // Safely parse DD-MM-YYYY format to Date object
    const parseDate = (str) => {
      if (!str || typeof str !== "string") return null;
      const [dd, mm, yyyy] = str.split("-");
      return new Date(`${yyyy}-${mm}-${dd}`); // Convert to YYYY-MM-DD
    };

    const startDate = parseDate(searchdata.startDate);
    const endDate = parseDate(searchdata.endDate);

    if (startDate) startDate.setHours(0, 0, 0, 0);
    if (endDate) endDate.setHours(0, 0, 0, 0);

    const keyword = searchdata?.searchmember?.toLowerCase() || "";

    const RequestList =
      requestData &&
      requestData?.filter((req) => {
        let dateMatch = true;
        const requestDate = parseDate(req.request_accept_date);
        if (requestDate && startDate && endDate) {
          requestDate.setHours(0, 0, 0, 0);
          dateMatch = requestDate >= startDate && requestDate <= endDate;
        }

        const statusMatch =
          searchdata.status === -1
            ? [0, 1, 2].includes(req.cancel_request_status)
            : req.cancel_request_status === searchdata.status;

        const keywordMatch =
          req.m_name.toLowerCase().includes(keyword) ||
          req.business_name.toLowerCase().includes(keyword) ||
          req.business_category.toLowerCase().includes(keyword) ||
          req.mobile_no.toLowerCase().includes(keyword);

        return statusMatch && dateMatch && keywordMatch;
      });

    setNewRequestData(RequestList);
  };

  useEffect(() => {
    filterData();
  }, [searchdata, requestData]);

  const GetCancelMemberRequestData = async () => {
    setIsLoading(true);

    let res = await getCancelMemberRequestList();
    setIsLoading(false);
    if (res?.data?.length > 0) {
      setRequestData(res?.data);
    } else {
      setRequestData([]);
    }
  };

  useEffect(async () => {
    GetCancelMemberRequestData();
  }, []);

  const submitApproveMemberRequest = async () => {
    setIsLoading(true);
    const resp = await approveCancelMemberRequest(JSON.stringify(cancelRequestId));
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setIsLoading(false);
      setApproveMemberRequestModal(false);
      GetCancelMemberRequestData();
    }
  };

  const expo_columns = [
    { label: "No", key: "c_m_r_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    {
      label: "Join Date",
      key: "joining_date"
    },
    {
      label: "Expire Date",
      key: "due_date"
    },
    { label: "Business Name", key: "business_name" },
    { label: "Business Category", key: "business_category" },
    { label: "Request Date", key: "request_date" },
    { label: "Subject", key: "subject" },
    { label: "Reason", key: "cancel_request_reason" },
    { label: "Approve Date", key: "request_accept_date" },
    { label: "Status", key: "cancel_status" }
  ];

  return (
    <>
      <Modal
        open={approveMemberRequestModal}
        onClose={() => setApproveMemberRequestModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "100%", textAlign: "center" }}>
              <Icon style={{ height: "128px", width: "128px" }}>
                <ReportGmailerrorredOutlined
                  color="warning"
                  style={{ height: "128px", width: "128px", opacity: "1" }}
                />
              </Icon>
              <br />
            </div>
            <p style={{ textAlign: "center" }}>Are You Sure You Want To Approve Request ?</p>
            {/* <hr /> */}
            <div style={{ margin: "10px auto", display: "flex", justifyContent: "center" }}>
              <Button
                style={{ margin: "auto 5px" }}
                variant="outlined"
                onClick={() => setApproveMemberRequestModal(false)}
              >
                NO
              </Button>
              <Button
                style={{ margin: "auto 5px" }}
                variant="contained"
                onClick={submitApproveMemberRequest}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Yes Approve
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Page title="Cancel Membership Requests | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Cancel Membership Requests
            </Typography>
          </Stack>
          <Card className="p-20 mb-15">
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Stack spacing={0}>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    adapterLocale={enGB}
                    style={{ marginTop: "0px" }}
                  >
                    <DatePicker
                      type="date"
                      name="s_date"
                      label="Request Approve Start Date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata.startDate
                          ? new Date(searchdata.startDate.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                          : null
                      }
                      onChange={(newDate) => {
                        if (newDate instanceof Date && !isNaN(newDate)) {
                          const day = String(newDate.getDate()).padStart(2, "0");
                          const month = String(newDate.getMonth() + 1).padStart(2, "0");
                          const year = newDate.getFullYear();
                          setsearchdata({
                            ...searchdata,
                            startDate: `${day}-${month}-${year}`
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={0}>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                    <DatePicker
                      type="date"
                      name="e_date"
                      label="Request Approve End Date"
                      inputFormat="dd/MM/yyyy"
                      value={
                        searchdata.endDate
                          ? new Date(searchdata.endDate.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                          : null
                      }
                      onChange={(newDate) => {
                        if (newDate instanceof Date && !isNaN(newDate)) {
                          const day = String(newDate.getDate()).padStart(2, "0");
                          const month = String(newDate.getMonth() + 1).padStart(2, "0");
                          const year = newDate.getFullYear();
                          setsearchdata({
                            ...searchdata,
                            endDate: `${day}-${month}-${year}`
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <TextField
                    style={{ marginTop: "0px" }}
                    autoComplete="off"
                    type="text"
                    label="Search Member"
                    name="search"
                    value={searchdata?.searchmember ? searchdata?.searchmember : ""}
                    onChange={(e) => {
                      setsearchdata({
                        ...searchdata,
                        searchmember: e.target.value
                      });
                    }}
                  />
                </Stack>
              </Grid>

              <Grid item xs={4}>
                <Stack spacing={3}>
                  <label>Request Status</label>
                  <Select
                    menuPortalTarget={document.body}
                    value={
                      requestPendingApproveOptions &&
                      requestPendingApproveOptions.map((option) => {
                        if (option.value == searchdata.status) {
                          return { value: option.value, label: option.label };
                        }
                      })
                    }
                    onChange={(e) => {
                      setsearchdata({ ...searchdata, status: e.value });
                    }}
                    options={
                      requestPendingApproveOptions &&
                      requestPendingApproveOptions.map((option) => {
                        return { value: option.value, label: option.label };
                      })
                    }
                  />
                </Stack>
              </Grid>

              <Grid xs={1} item sx={{ display: "flex", justifyContent: "flex-end" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <Button variant="outlined" onClick={ClearSearchResult}>
                    Clear
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Card>

          <Card className="p-2" style={{ padding: "15px" }}>
            {requestData && (
              <>
                <Button className="btn btn-export">
                  <CSVLink
                    data={requestData}
                    headers={expo_columns}
                    filename={"Cancel Member Request.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>

                <DataTable
                  style={{ overflow: "hidden" }}
                  filter
                  pagination
                  highlightOnHover
                  columns={columns}
                  data={newOBTData != null ? newOBTData : []}
                  progressPending={isLoading}
                  progressComponent={<CustomLoader />}
                />
              </>
            )}
          </Card>
        </Container>

        {/* Request Pending / Approve Modal */}
      </Page>
    </>
  );
}
